import {FC} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {TeamPage} from './TeamPage'

const TeamPageWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.TEAMPAGE'})}</PageTitle>
      <TeamPage />
    </>
  )
}

export {TeamPageWrapper}
